import React from 'react'
import styled from 'styled-components'
import { useStoreState } from 'easy-peasy'
import { useTranslations } from '../../utils/Text'
import Image from './Image'
import media from '../../utils/media'
import Paragraph from './Paragraph'

const Wrapper = styled.div`
  a {
    color: #414141 !important;
  }
`

const FooterIcons = styled.div`
  display: flex;
  ${media.mobileL`
    justify-content: center;
  `};
`

const Background = styled.div`
  background-color: ${props =>
    props.bgColor ? props.bgColor : 'transparent'};
  padding: 45px 35px;
  border-bottom: ${props => props.borderB};
`

export default function LandingFooter({ config }) {
  const {
    text,
    links,
    bgColor,
    borderB,
    instagramSrc,
    linkInstagram,
    instagramAlt,
    margin,
    maxWidth,
    facebookSrc,
    linkFacebook,
    facebookAlt,
  } = config

  const iconInstagram = useTranslations(instagramSrc, {})

  const locale = useStoreState(state => state.locale.locale)

  const linkInstagramHref = useTranslations(linkInstagram, {})

  const iconFacebook = useTranslations(facebookSrc, {})
  const linkFacebookHref = useTranslations(linkFacebook, {})

  return (
    <>
      <Wrapper locale={locale}>
        {locale !== 'en' && (
          <Background
            bgColor={bgColor}
            margin={margin}
            borderB={borderB}
          >
            <FooterIcons>
              <div className="d-inline pr-2">
                <a href={linkInstagramHref}>
                  <Image
                    src={iconInstagram}
                    alt={instagramAlt}
                    maxWidth={maxWidth}
                  />
                </a>
              </div>
              <>
                <a href={linkFacebookHref}>
                  <Image
                    src={iconFacebook}
                    alt={facebookAlt}
                    maxWidth={maxWidth}
                  />
                </a>
              </>
            </FooterIcons>
            {links.map(link => {
              return (
                <div key={link.text}>
                  <Paragraph
                    paragraph={link.text}
                    textAlign={link.textAlign}
                    textAlignMobile={link.textAlignMobile}
                    marginB={link.marginB}
                    fontSize={link.fontSize}
                    lineHeight={link.lineHeight}
                    padding={link.padding}
                    fontFamily={link.fontFamily}
                  />
                </div>
              )
            })}
          </Background>
        )}
        <div>
          {text && (
            <Paragraph
              paragraph={text.text}
              textAlign={text.textAlign}
              marginB={text.marginB}
              fontSize={text.fontSize}
              lineHeight={text.lineHeight}
              padding={text.padding}
              classN="form-subtitle"
              fontFamily={text.fontFamily}
            />
          )}
        </div>
      </Wrapper>
    </>
  )
}
